let id = 0;

const defaultOptions = {};

function createNotification(options) {
  return {
    ...defaultOptions,
    ...options,
    id: id++,
  };
}

export { createNotification };
